import { render, staticRenderFns } from "./SharedFolderList.vue?vue&type=template&id=2bcb4512&"
import script from "./SharedFolderList.vue?vue&type=script&lang=ts&"
export * from "./SharedFolderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports